import { getCumulAuthorization } from './getCumulAuthorization';
import { getCumulDashboard } from './getCumulDashboard';

export const BusinessIntelligenceService = {
  getCumulAuthorization,
  getCumulDashboard,
};
